import React, { useState } from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";

const AddDepartmentComponent = ({ onSelectDepartment, onBack, onCancel }) => {
  const departments = [
    { id: 1, name: "Tech", deptId: "Department ID: 1" },
    { id: 2, name: "Product", deptId: "Department ID: 2" },
    { id: 3, name: "Sales", deptId: "Department ID: 3" },
    { id: 4, name: "EST", deptId: "Department ID: 4" },
    { id: 5, name: "CST", deptId: "Department ID: 5" },
  ];

  const [selectedDept, setSelectedDept] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredDepartments = departments.filter(dept =>
    dept.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelectDepartment = (dept) => {
    setSelectedDept(dept);
  };

  const handleSaveAndContinue = () => {
    if (selectedDept && onSelectDepartment) {
      onSelectDepartment(selectedDept);
    }
  };

  return (
    <div className="cohortsec1">
      <div className="maininput">
        <div className="bp-form-container" style={{ padding: '0', backgroundColor: 'transparent' }}>
          <Box sx={{ width: '100%', p: 3, backgroundColor: '#fff', borderRadius: '20px', minHeight: '40vh' }}>
            <h2 style={{ marginBottom: '24px', fontWeight: 600, color: '#333' }}>Select Department</h2>
            
            {/* Search Input */}
            <TextField
              fullWidth
              placeholder="Search department..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              sx={{
                mb: 3,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: '#f5f5f5',
                  '& fieldset': {
                    borderColor: '#e0e0e0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#bdbdbd',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#1976d2',
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#757575' }} />
                  </InputAdornment>
                ),
              }}
            />

            {/* Department List */}
            <List sx={{ 
              width: '100%',
              bgcolor: '#fff',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
              maxHeight: '400px',
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}>
              {filteredDepartments.map((dept) => (
                <React.Fragment key={dept.id}>
                  <ListItem 
                    button
                    selected={selectedDept?.id === dept.id}
                    onClick={() => handleSelectDepartment(dept)}
                    sx={{
                      py: 2.5,
                      px: 3,
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#e3f2fd',
                        '&:hover': {
                          backgroundColor: '#bbdefb',
                        }
                      }
                    }}
                  >
                    <ListItemText 
                      primary={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                          <span style={{ fontWeight: 600, fontSize: '16px', color: '#333' }}>{dept.name}</span>
                          <span style={{ color: '#666', fontSize: '14px' }}>{dept.deptId}</span>
                        </div>
                      }
                    />
                  </ListItem>
                  {dept.id !== filteredDepartments[filteredDepartments.length - 1].id && (
                    <Divider component="li" sx={{ margin: 0 }} />
                  )}
                </React.Fragment>
              ))}
            </List>

          
          </Box>
        </div>
      </div>
    </div>
  );
};

export default AddDepartmentComponent;